<template>
	<span class="theme-selector" @click="rotateTheme"><span class="fi" v-html="icon"></span></span>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from "vue";
import {injectEnv} from "@fd/Environment";

const props = defineProps({});

const env = injectEnv();
const THEMES = [
	{ name: "classic", icon: "&#xEE75;"},
	{ name: "dark", icon: "&#xEE74;"},
	{ name: "light", icon: "&#xEE73;"}
];

const theme = ref<string>();
const icon = computed<string>(() => {
	for (let t of THEMES) {
		if (theme.value === t.name) return t.icon;
	}
	return "&#xEE00;";
});

function retrieveTheme():string {
	let html = document.documentElement;
	let l = html.classList;
	let name = "";
	for (let t of THEMES) {
		if (l.contains(t.name)) {
			name = t.name;
			break;
		}
	}
	theme.value = name;
	return name;
}

function saveTheme(t:string):Promise<void> {
	return env.net.fetch("api/users/theme?name="+t, "PUT")
		.then((response) => {
		});
}

function setTheme(t:string):void {
	let html = document.documentElement;
	let l = html.classList;
	for (let t of THEMES) {
		l.remove(t.name);
	}

	l.add(t);
	theme.value = t;
	saveTheme(t);
}

function rotateTheme() {
	let t = retrieveTheme();
	for (let i = 0; i < THEMES.length; i++) {
		if (THEMES[i].name === t) {
			const nextIdx = (i + 1) % THEMES.length;
			setTheme(THEMES[nextIdx].name);
			return;
		}
	}
	setTheme('classic');
}

let observer:MutationObserver;

function startObservingRoot() {
	retrieveTheme();
	observer = new MutationObserver((mutations) => {
		// attributes mutated
		retrieveTheme();
	});
	observer.observe(document.documentElement, { attributes: true })
}

function stopObservingRoot() {
	if (observer) observer.disconnect();
}

onMounted(startObservingRoot);
onUnmounted(stopObservingRoot);

</script>

<style>
.theme-selector {
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: 0;
	border-radius: 50%;
	aspect-ratio: 1 / 1;
	background-color: var(--bg);
	color: var(--fg);
	height: var(--search-height);
	cursor: pointer;
}
.theme-selector > .fi {
	line-height: 18px;
	width: 18px;
}
</style>